<template>

    <div class="filter-top">
    <form method="GET" class="container">

        <div class="filter-bar">

            <!-- Mobile Filter Button -->
            <div class="d-md-none">
                <button class="btn btn-filter" @click.prevent="mobileOpen = !mobileOpen">
                    <i class="fas fa-bars"></i> Filter
                </button>
            </div>

            <!-- Search Alert Button -->
            <div v-if="mode == 'listings' || mode == 'sales'" class="order-md-2">
                <button-alert :mode="mode" @on-set-alert="$emit('on-set-alert')" :compact="true" />
            </div>

            <div class="order-md-4 ml-md-auto d-flex">

                <filter-single
                    v-if="sortingOptions.length"
                    key="sort"
                    name="sort"
                    default-label="Sort:"
                    align="right"
                    :options="sortingOptions"
                    :selected="sorting"
                    :open="focus == 'sort'"
                    :disabled="appDisabled"
                />

                <slot></slot>

            </div>

            <!-- Actual Filters (hidden mobile) -->
            <div :class="['filter-bar-filters', 'order-md-1', {'mobile-open': mobileOpen}]">

                <div class="d-md-none text-right mb-3">
                    <a @click.prevent="mobileOpen = false" class="btn btn-primary" href="#">See {{ count }} Results</a>
                </div>

                <filter-group name="filter-bar-main" label="Filter:" :filters="filtersMain"  />

                <div class="filter-bar-more-container">

                    <button
                        :class="['btn', 'btn-filter', 'btn-more', 'd-none', 'd-md-block', {active: moreOpened, disabled: appDisabled}]"
                        @click.prevent="toggleFilter('more')"
                        href="#">
                            More...
                    </button>

                    <filter-group
                        v-if="moreOpened || mobileOpen"
                        name="filter-bar-more"
                        label=""
                        :filters="filtersMore"
                        v-click-outside="(ev) => dismissMore(ev, 'more')"
                        @signup="(ev) => doSignup(ev)"
                    />
                    <!-- :open="moreOpened"  -->

                </div>

            </div>

        </div>

    </form>
    </div>

</template>

<script>

    /* global appData */

    import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
    import FilterGroup from '@/mls-filter/components/filters/FilterGroup.vue';
    import FilterSingle from '@/mls-filter/components/filters/FilterSingle.vue';
    import ButtonAlert from '@/mls-filter/components/ButtonAlert.vue';

    export default {
        props: {
            sortingOptions: Array,
        },

        data: () => ({
            mobileOpen: false,
        }),

        computed: {

            ...mapState([
                'appDisabled',
                'selected',
                'sorting',
                'focus',
                'alerts',
                'count',
                'mode',
            ]),

            ...mapGetters([
              'filtersMain',
              'filtersMore',
              'filtersMoreNames',
              'moreOpened',
            ]),

        },

        methods: {

            dismissMore(ev, filter) {
                // ok to dismiss all
                if (!this.mobileOpen) {
                    this.$store.dispatch('dismissFilters');
                }
            },

            doSignup(ev) {
                this.mobileOpen = false;
                this.dismissMore(ev, 'more');
                appData.externals.showSignup();
            },

            numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },

            ...mapActions([
                'toggleFilter',
                'applyFilter',
            ]),
        },

        watch: {
            mobileOpen(to, from) {

                if (to) {
                    document.body.style.overflowY = 'hidden';
                } else {
                    document.body.style.overflowY = 'auto';
                }

            },
        },

        components: {
            FilterGroup,
            FilterSingle,
            ButtonAlert,
        },
    };

</script>


<style lang="scss">

    @import "@/common/scss/_variables.scss";
    @import "@/common/scss/_mixins.scss";

    .filter-bar {

        position: relative;

        //...
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        margin: 0 -4px;

        @include media-breakpoint-down(sm) {
            flex-wrap: wrap;
        }

        & > * {

            padding: 0 4px;

            @include media-breakpoint-down(sm) {
                flex-basis: percentage(1/3) !important;
                max-width: percentage(1/3) !important;
                & > * {
                    width: 100%;
                }
            }
        }

        .btn-map-view {
            @include media-breakpoint-down(md) {
                display: block;
                position: absolute;
                height: auto;
                bottom: 0;
                right: 12px;
                bottom: -55px;
                width: 100px;
                z-index: 1000;
            }
        }


        .filter-label {
            white-space: nowrap !important;
        }

        .filter-menu {

            // all filter menus (including the sort button)
            position: relative;
            margin: 0;
            display: block;
            width: 100%;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;

            &.filter-sort {

                padding-right: 8px;
                .filter-label {
                    display: none;
                // @include media-breakpoint-down(sm) {
                //     display: none;
                // }
                }
            }

            .filter-label {
                // flex-wrap: nowrap;
                flex-basis: percentage(1/3);
                width: percentage(1/3);
                flex-shrink: 0;
                font-size: 14px;
            }
        }

        .filter-checkbox {
            color: black;
        }



        .filter-bar-filters {

            display: flex;

            // top level filter-items
            @include media-breakpoint-down(sm) {

                display: none;
                flex-direction: column;
                position: fixed;
                overflow: scroll;
                top: 0;
                bottom: 0;
                left: 0;


                z-index: 4000;

                width: 100%;
                flex-basis: 100% !important;
                max-width: 100% !important;
                padding: 15px;

                background-color: white;

                .btn-filter {
                    background-color: $white;
                    border-color: $dark;
                    color: $dark;
                    &.active {
                    @include media-breakpoint-down(sm) {
                        background-color: $primary !important;
                        color: white !important;
                        border-color: white;
                    }
                    }
                }

                &.mobile-open {
                    display: flex;
                }

                .filter-menu {

                    margin: 2.5px 0;

                    .filter-label {
                        color: $primary !important;
                        font-weight: bold;
                        text-align: center;
                    }

                }
            }

            .btn-more {
                &.active {
                    background-color: white;
                    color: $primary;
                }
            }

            .filter-bar-main.filter-items {
                // main filter-items
                width: 100%;
                align-items: center;
                display: flex;
                flex-flow: column nowrap;
                margin: 0;

                min-height: 175px;
                // background: red;

                @include media-breakpoint-up(md) {
                    min-height: unset;
                    margin: 0 -4px;
                    flex-flow: row nowrap;
                }


                & > .filter-label {
                    @include media-breakpoint-down(sm) { display: none; }
                }

                @include media-breakpoint-up(md) {

                    padding-right: 4px;

                    .filter-menu {
                        padding: 0 4px !important;
                        .filter-label {
                            // dont display labels for main filters on desktop
                            @include media-breakpoint-up(md) {
                                display: none !important;
                            }
                        }

                        .btn-filter {
                            &.active {
                                background-color: white;
                                color: $primary;
                            }
                        }
                    }
                }
            }

            .filter-bar-more-container {

                position: relative;
                @include media-breakpoint-up(md) {
                    padding-left: 4px;
                }

                .filter-bar-more.filter-items {

                    // more filter-items
                    flex-direction: column !important;
                    width: 100%;
                    margin: 0;

                    // DESKTOP ONLY
                    @include media-breakpoint-up(md) {

                        background: white;
                        color: #333;
                        border: 1px solid $lighter;
                        box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.05);

                        position: absolute;
                        z-index: 2000;
                        width: 400px;
                        margin-top: 3px;
                        padding: 20px;

                        display: none;
                        &.open { display: flex; }
                    }

                    .filter-menu {

                        margin: 5px 0;

                        .filter-label {
                            // color: $dark !important;
                        }

                        .btn-filter {
                            background-color: $white;
                            border-color: $dark;
                            color: $dark;
                            &.active {
                                background-color: $primary !important;
                                color: white !important;
                                border-color: white;
                            }
                        }
                    }
                }
            }
        }
    }

</style>


